var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "rack"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "card-headerfrm filter_main row",
    staticStyle: {
      "margin": "1px 16px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-actions col-md-6 "
  }, [_c('div', {
    staticClass: "float-right"
  }, [_c('a', {
    attrs: {
      "title": "Go To Packing "
    },
    on: {
      "click": _vm.showList
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    staticStyle: {
      "font-size": "18px"
    },
    attrs: {
      "style": "font-size:18px"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12",
    attrs: {
      "id": "printContent"
    }
  }, [_c('div', {
    staticClass: "card-headerfrm"
  }, [_c('i', {
    on: {
      "ok": function($event) {}
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("OrderId : ")]), _c('b', [_vm._v(_vm._s(this.pono1.orderId))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Boxid : ")]), _c('b', [_vm._v(_vm._s(this.pono1.boxId))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Total skus : ")]), _c('b', [_vm._v(_vm._s(this.pono1.totalSkus))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Total Quantity : ")]), _c('b', [_vm._v(_vm._s(this.pono1.totalQty))])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "card-body",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('td', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "font-size": "13px",
      "color": "#413535"
    },
    attrs: {
      "colspan": "4",
      "align": "center"
    }
  }, [_c('b', [_vm._v(" Box Details")])])]), _vm._v(" "), _c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Client Product ID")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Product Name")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Product Eancode")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Quantity")])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.boxdatas), function(data) {
    return [_c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.clientproductid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.productname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.eancode))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.qty))])])]
  })], 2)])])])], 1), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-bottom": "10px",
      "margin-right": "20px",
      "float": "right"
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.loading ? _vm.loadingText : 'Print')
    },
    on: {
      "click": function($event) {
        _vm.print()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" Print")])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "padding-bottom": "4px"
    }
  }, [_c('h6', [_vm._v("Packed Data")])])
}]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-64736a87", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64736a87","hasScoped":true}!./src/views/components/packingb2c/printpackdata.component.html
// module id = 1963
// module chunks = 0